import {useEffect, useState, useRef, useMemo} from 'react';
import { BrowserRouter as Router, Route, Routes,useLocation } from 'react-router-dom';
import Home from '../components/home/Home';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import ProductPage from '../components/productPage/ProductPage';
import Cart from '../components/Cart/Cart';
import Payment from '../components/Payment/Payment';
import Terms from '../components/T&C/Terms';
import About from '../components/About/About';
import Contact from '../components/Contact/Contact';
import Disclaimer from '../components/T&C/Disclaimer';
import PrivacyPolicy from '../components/T&C/PrivacyPolicy';
import Refund from '../components/T&C/Refund';
import ShippingPolicy from '../components/T&C/ShippingPolicy';
import Cate from '../components/categories/Cate';
import Products from '../components/product/Products';
import { useProduct } from "../context/ProductContext";
import { useLocalContext } from '../context/LocalContext';
import FreezeModal2 from '../components/FreezeModal/FreezeModal2';
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs';
import SiteDisclaimer from '../components/SiteDisclaimer/SiteDisclaimer';

const ScrollToTop = () => {
    const location = useLocation();
    const { setSelectedAntiv } = useProduct();
  
  
    useEffect(() => {
      window.scrollTo(0, 0);
    
      const categories = [
        "Avast",
        "McAfee",
        "Norton",
        "TotalAV",
        "AVG",
        "Bitdefender",
        "Kaspersky",
      ];
    
   
      const matchedCategory = categories.find((category) =>
        location.pathname.toLowerCase().includes(category.toLowerCase())
      );
    
      if (matchedCategory) {
        setSelectedAntiv(matchedCategory); 
      }
    }, [location, setSelectedAntiv]);
    
    
    return null;
  };

  const URLStateHandler = () => {
    const location = useLocation();
    const { products, setProductToShow, setSelectedAntiv } = useProduct();
    
    useEffect(() => {
      const validateRouteAndSetProduct = (path) => {
        // Extract category and product name from the path
        const pathSegments = path.split('/').filter(Boolean); // e.g., ['/avg', '/avg-internet-security']
        if (pathSegments.length === 2) {
          const [category, productRoute] = pathSegments;
  
          // Find the category in allProducts
          const categoryKey = Object.keys(products).find(
            (key) => key.toLowerCase() === category.toLowerCase()
          );
  
          if (categoryKey) {
            // Find the product in the category
            const product = products[categoryKey].find(
              (item) => item.route === `/${category}/${productRoute}`
            );
  
            if (product) {
              // Set the product and category in context
              setProductToShow(product);
              setSelectedAntiv(categoryKey);
              console.log('Product found and set:', product);
            } else {
              console.warn('Product not found in category:', productRoute);
            }
          } else {
            console.warn('Category not found:', category);
          }
        }
      };
  
      validateRouteAndSetProduct(location.pathname);
    }, [location.pathname, products, setProductToShow, setSelectedAntiv]);
  
    return null;

  };

  
  
const categoryMetadata = {
  Avast: {
    title: "Avast Security & Privacy Suite",
    bannerImg:
      "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613029/avast_antitrack_premium_r0zpzq_esjbnv.png",
    backgroundImage: "",
    // logo:
    //   "https://res.cloudinary.com/dlehcpiyn/image/upload/v1763455583/avast_logo_2021_cjo2d9_yeibbo.png",

    whyChoose:
      "Avast Security & Privacy Suite is designed to keep day-to-day protection and privacy tools in one place. The dashboard separates scans, web safety, and network checks into clear sections, making it easy to review what’s running and what needs attention. Feature availability can differ by plan, operating system, and region.",

    features: [
      "Real-time protection for files, apps, and downloads",
      "Firewall controls with app permission management (where available)",
      "Sandbox-style environment for testing unknown files (supported plans)",
      "Web protection to help reduce exposure to risky or deceptive sites",
      "Payment-focused browsing mode for sensitive tasks (supported plans)",
      "Network inspection to review connected devices and router status",
      "Webcam and microphone access notifications on compatible systems",
      "Ransomware-style folder protection on supported devices",
      "Automatic updates with configurable scan schedules",
      "Focus / Do Not Disturb mode for streaming and gaming",
      "Basic visibility into startup items and background activity",
      "Cross-platform coverage depending on subscription tier"
    ],
    testimonials: []
  },

  McAfee: {
    title: "McAfee Total Protection Hub",
    bannerImg:
      "https://res.cloudinary.com/dppalz0f4/image/upload/v1764612929/mcafee_total_protection_yfphhy_joougx.png",
    backgroundImage: "",
    // logo:
    //   "https://res.cloudinary.com/dlehcpiyn/image/upload/v1763455577/mcafee_logo_w0hhbh_l8l9s4.png",

    whyChoose:
      "McAfee Total Protection Hub brings security, privacy options, and device utilities into a unified dashboard. It’s structured around common tasks such as scanning, safer browsing, and account protection, with shortcuts that help you check status quickly. Modules and inclusions vary depending on plan, platform, and region.",

    features: [
      "Real-time malware protection with scheduled scan options",
      "Web safety checks for links, downloads, and browsing activity",
      "VPN access included in eligible subscriptions (limits may apply)",
      "Identity or exposure alerts in supported regions",
      "Firewall and network monitoring options on compatible systems",
      "Password manager for storing and syncing credentials",
      "Device performance tools for cleanup and startup review",
      "Encrypted storage/vault tools in supported plans",
      "Family features and parental tools in select subscriptions",
      "Central device status page with alerts and recommendations",
      "Automatic security updates in the background"
    ],
    testimonials: []
  },

  TotalAV: {
    title: "TotalAV Smart Security Dashboard",
    bannerImg:
      "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613029/totalav_total_security_xnxsqp_u7twfx.svg",
    backgroundImage: "",
    // logo:
    //   "https://res.cloudinary.com/dmfs7bnl6/image/upload/v1760604708/totalav_screenshot_preview_mdjrjc_mkidzt.png",

    whyChoose:
      "TotalAV Smart Security Dashboard keeps scanning, web safety, and cleanup tools together in a simple interface. Guided scans and quick actions help users handle routine maintenance without digging through complex settings. Exact features, limits, and layout can vary by plan, device type, and region.",

    features: [
      "Real-time monitoring for apps, downloads, and files",
      "On-demand and scheduled scanning options",
      "Web filtering tools to help flag risky links and pages",
      "VPN access included in applicable subscriptions (limits may apply)",
      "Password vault tools in supported tiers",
      "Junk, cache, and temporary file cleanup utilities",
      "One-click scan flow that checks common security and performance items",
      "Browser privacy tools such as tracker or cookie controls (where supported)",
      "Startup and performance optimization options",
      "Consistent UI across supported desktop and mobile platforms",
      "Recurring scan and cleanup scheduling"
    ],
    testimonials: []
  },

  AVG: {
    title: "AVG Ultimate Protection Center",
    bannerImg:
      "https://res.cloudinary.com/dppalz0f4/image/upload/v1764611899/avg_ultimate_bg_cflsz6_vbqgxx.png",
    backgroundImage: "",
    // logo:
    //   "https://res.cloudinary.com/dmfs7bnl6/image/upload/v1760622320/avg_logo_white_hwqrpj_cnqs96.png",

    whyChoose:
      "AVG Ultimate Protection Center combines threat protection, privacy tools, and tune-up utilities in a task-first layout. Shortcuts help you run scans, apply updates, and manage performance in a few clicks. Included modules depend on your plan, device platform, and version.",

    features: [
      "Real-time scanning for files, downloads, and web activity",
      "Email protection for attachments and link checks (where supported)",
      "Firewall controls with per-app permissions on compatible devices",
      "VPN service included in supported tiers (limits may apply)",
      "Tune-up utilities for storage cleanup and performance maintenance",
      "Smart Scan that reviews security, privacy, and performance areas",
      "Secure deletion / file shredding on supported systems",
      "Focus or gaming mode to reduce notifications",
      "Software updater for selected third-party apps (availability varies)",
      "Multi-device view for eligible subscriptions"
    ],
    testimonials: []
  },

  Norton: {
    title: "Norton 360 Security Center",
    bannerImg:
      "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613025/norton_antivirus_plus_dns2ib_z20ggp.png",
    backgroundImage: "",
    // logo:
    //   "https://res.cloudinary.com/dmfs7bnl6/image/upload/v1760604707/norton_logo_2010_h7reya_evmvq8.png",

    whyChoose:
      "Norton 360 Security Center organizes protection, privacy options, and account-focused tools into a guided dashboard. Tiles highlight recent events and items that may need attention, helping users stay on top of device status. Plan inclusions—like VPN, backup storage, or family tools—vary by subscription, platform, and region.",

    features: [
      "Real-time protection with scheduled scan support",
      "VPN access included in applicable Norton 360 tiers (limits may apply)",
      "Cloud backup options in eligible plans (storage varies by tier/platform)",
      "Password manager for storing and syncing logins",
      "Parental controls in select subscriptions and regions",
      "Webcam protection prompts (SafeCam) on compatible devices",
      "Account and exposure monitoring features where available",
      "Smart firewall with app and network visibility",
      "Performance utilities for routine device upkeep (supported systems)",
      "Browser add-ons for safer search and browsing support",
      "Cross-platform coverage based on plan"
    ],
    testimonials: []
  },

  Bitdefender: {
    title: "Bitdefender Total Security Hub",
    bannerImg:
      "https://res.cloudinary.com/dppalz0f4/image/upload/v1764611901/bitdefender_total_security_dvxs6q_ehzl3m.png",
    backgroundImage: "",
    // logo:
    //   "https://res.cloudinary.com/dmfs7bnl6/image/upload/v1760622314/bitdefender_image_baf1k5_vxg4dd.png",

    whyChoose:
      "Bitdefender Total Security Hub provides a tile-based dashboard for protection, privacy controls, and device profiles. Reports summarize recent activity and suggest follow-up actions, while modes can reduce interruptions during work or entertainment. Tools and limits vary by plan, platform, and region.",

    features: [
      "Real-time protection with web filtering for risky content",
      "Anti-phishing and malicious link warnings (where supported)",
      "VPN component with plan-based data limits",
      "Payment-focused browser mode for sensitive tasks (supported plans)",
      "Privacy tools to reduce tracking on supported browsers",
      "Camera and microphone permission prompts on compatible devices",
      "Family and parental tools included in certain tiers",
      "Performance and battery profiles for work, travel, or gaming",
      "Security recommendations for outdated or risky settings",
      "Encryption and secure deletion tools on supported systems",
      "Wi-Fi security advisor for reviewing network setup"
    ],
    testimonials: []
  },

  Kaspersky: {
    title: "Kaspersky Adaptive Security Center",
    bannerImg:
      "https://res.cloudinary.com/dppalz0f4/image/upload/v1764612653/kaspersky_security_cloud_p5vhrh_l4rrqt.png",
    backgroundImage: "",
    // logo:
    //   "https://res.cloudinary.com/dmfs7bnl6/image/upload/v1760604701/kaspersky_logo_bw_qoqcdk_wnqqrk.png",

    whyChoose:
      "Kaspersky Adaptive Security Center brings protection and privacy tools together with a guided dashboard for scans, web safety, and device status. Modes and notifications can be tuned to keep the experience quiet during focus-heavy sessions. Available modules depend on subscription level, operating system, and region.",

    features: [
      "Real-time monitoring with configurable scan schedules",
      "Safe Money / protected browser mode for checkout and banking pages",
      "Password manager tools in eligible subscriptions",
      "Camera and microphone activity alerts on supported devices",
      "Backup and restore support tools (where included)",
      "Family and parental options in select plans",
      "VPN functionality in supported subscriptions (limits may apply)",
      "Cloud-assisted updates and protection improvements",
      "Performance helpers for battery and speed optimization (supported systems)",
      "Central view of linked devices and protection status",
      "Activity reporting with suggested next steps",
      "Low-interruption scheduling for maintenance scans"
    ],
    testimonials: []
  }
};




const AppContent = () => {

  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Update `isMobile` state on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const blogs = [
    { id: '01', route: 'Norton' },
    { id: '02', route: 'McAfee' },
    { id: '03', route: 'Kaspersky' },
    { id: '04', route: 'Bitdefender' },
  ];

  // Check if the current path matches one of the blog routes
  const isBlogRoute = blogs.some((blog) => location.pathname === `/${blog.route.toLowerCase()}`);

  const {webinfo, showCallModal, setShowCallModal} = useLocalContext();
  const [isMobileView] = useState(window.innerWidth < 768);

  /* ---------------------------
     POPUP CONFIG
  ---------------------------- */
  const POPUP_CONFIG = useMemo(
    () => [
      // {
      //   id: "norton",
      //   match: ["/norton"],
      //   exact: true,
      //   theme: "norton",
      //   delayMs: 1500,
      //   countdownSec: 3,
      //   phoneOverride: "",
      // },
      // {
      //   id: "mcafee",
      //   match: ["/mcafee"],
      //   exact: true,
      //   theme: "mcafee",
      //   delayMs: 1500,
      //   countdownSec: 3,
      //   phoneOverride: "",
      // },
      // {
      //   id: "kaspersky",
      //   match: ["/kaspersky"],
      //   exact: true,
      //   theme: "kaspersky",
      //   delayMs: 1500,
      //   countdownSec: 3,
      //   phoneOverride: "",
      // },
      // {
      //   id: "bitdefender",
      //   match: ["/bitdefender"],
      //   exact: true,
      //   theme: "bitdefender",
      //   delayMs: 1500,
      //   countdownSec: 3,
      //   phoneOverride: "",
      // },
    ],
    []
  );

  const activePopup = useMemo(() => {
    const path = location.pathname.toLowerCase();
    return POPUP_CONFIG.find((p) =>
      p.match.some((m) => {
        const mm = m.toLowerCase();
        if (p.exact) return path === mm;
        return path === mm || path.startsWith(mm + "/");
      })
    );
  }, [location.pathname, POPUP_CONFIG]);

  // phone priority: override > phonecall > phone
  const popupPhone = useMemo(() => {
    const override = activePopup?.phoneOverride?.trim();
    return override || webinfo?.phoneCall || webinfo?.phone || "";
  }, [activePopup?.phoneOverride, webinfo?.phoneCall, webinfo?.phone]);

  /* ---------------------------
     ✅ ONCE-ONLY GUARD
     - prevents reopen after user closes
     - resets automatically when route changes
  ---------------------------- */
  const openedOnceRef = useRef(false);

  // reset "once" guard when user navigates to a different path
  useEffect(() => {
    openedOnceRef.current = false;
  }, [location.pathname]);

  /* ---------------------------
     Countdown state (for Cate UI)
     Modal opens ONLY after countdown ends
  ---------------------------- */
  const [countdownActive, setCountdownActive] = useState(false);
  const [timer, setTimer] = useState(0);

  const countdownIntervalRef = useRef(null);
  const countdownTimeoutRef = useRef(null);

  useEffect(() => {
    // cleanup first
    if (countdownIntervalRef.current) clearInterval(countdownIntervalRef.current);
    if (countdownTimeoutRef.current) clearTimeout(countdownTimeoutRef.current);

    setCountdownActive(false);
    setTimer(0);

    // no popup route => close modal and stop
    if (!activePopup) {
      if (showCallModal) setShowCallModal(false);
      return;
    }

    // ✅ already opened once on this path => do nothing
    if (openedOnceRef.current) return;

    // if modal is open already => do nothing
    if (showCallModal) return;

    countdownTimeoutRef.current = setTimeout(() => {
      const secs = Number(activePopup.countdownSec || 3);
      setCountdownActive(true);
      setTimer(secs);

      countdownIntervalRef.current = setInterval(() => {
        setTimer((t) => {
          if (t <= 1) {
            clearInterval(countdownIntervalRef.current);
            setCountdownActive(false);

            openedOnceRef.current = true;
            setShowCallModal(true);
            return 0;
          }
          return t - 1;
        });
      }, 1000);
    }, Number(activePopup.delayMs || 0));

    return () => {
      if (countdownIntervalRef.current) clearInterval(countdownIntervalRef.current);
      if (countdownTimeoutRef.current) clearTimeout(countdownTimeoutRef.current);
    };
  }, [
    activePopup?.id,
    activePopup?.delayMs,
    activePopup?.countdownSec,
    showCallModal,
    setShowCallModal,
  ]);

  // ✅ if user closes the modal, also mark openedOnce=true so it won't start again
  const handleCloseModal = () => {
    openedOnceRef.current = true;
    setShowCallModal(false);
  };


    return (
       <>
        {!(isMobile && isBlogRoute) && <Header />}
        {/* <NumberPinned /> */}
        <URLStateHandler />
        <ScrollToTop />
        {showCallModal && <FreezeModal2 phoneNumber={popupPhone || webinfo.phone} onClose={handleCloseModal} />}
      {/* {(isMobileView && showCallModal) && <FreezeModal phoneNumber={webinfo.phone}/>} */}
        <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/home" element={<Home />} />
            <Route exact path="/about" element={<About />} />
            <Route exact path="/contact" element={<Contact />} />
            <Route exact path="/whychooseus" element={<WhyChooseUs />} />
            <Route exact path="/disclaimer" element={<Disclaimer />} />
            <Route exact path="/shop" element={<Products />} />
            <Route path="/:category" element={<Cate categoryMetadata={categoryMetadata} countdownActive={countdownActive} popupTimer={timer} />} />
            <Route path='/:antiv/:productname' element={<ProductPage />} />
            <Route  path="/your-cart" element={<Cart />} />
            <Route  path="/payment" element={<Payment />} />
            <Route  path="/terms-and-conditions" element={<Terms />} />
            <Route  path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route  path="/refund-policy" element={<Refund />} />
            <Route  path="/shipping-policy" element={<ShippingPolicy />} />
        </Routes>
        {location.pathname !== "/disclaimer" && <SiteDisclaimer />}
        <Footer />
     </>
  )
}

const Container = () => {
  return (
    <Router basename="/en/antivirus">
      <AppContent />
    </Router>
  );
};


export default Container